import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPostFiles, doPut, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9015/api'

export const getTerminate = () => {
  const url = `${API_ROOT}/v1/legal/terminate/page`
  return doGet(url)
}

export const searchDocumentOfTerminate = (request) => {
  const url = `${API_ROOT}/v1/legal/terminate/search`
  return doPost(url, request)
}

export const getDocumentOfTerminateByid = (litigationId, terminateId) => {
  const url = `${API_ROOT}/v1/legal/terminate/get?litigationId=${litigationId}&&terminateId=${terminateId}`
  return doGet(url)
}

export const saveDocumentOfTerminate = (request, litigationId) => {
  const url = `${API_ROOT}/v1/legal/terminate/save/${litigationId}`
  return doPostFiles(url, request)
}

export const sendRequestApproveDocumentOfTerminate = (litigationId, terminateId) => {
  const url = `${API_ROOT}/v1/legal/terminate/request-approve/${litigationId}/${terminateId}`
  return doPost(url)
}

export const approvedDocumentOfTerminate = (litigationId, request) => {
  const url = `${API_ROOT}/v1/legal/terminate/approved/${litigationId}`
  return doPut(url, request)
}

export const downloadCallDocumentOfTerminate = (litigationTerminateId) => {
  const url = `${API_ROOT}/files/${litigationTerminateId}/litigation/terminate/letter`
  return doDownload(url)
}
